<template>
    <div :class="$style.template">
        <template v-if="!isEmpty">
            <div
                ref="card"
                :class="$style.card"
                :style="{
                    height: cardHeight
                }"
            >
                <img :src="props.src" alt="" />
                <div v-if="props.showLayer" :class="$style.buttons" @click="handleViewDetail">
                    <template v-if="!isMobile">
                        <pt-button
                            v-if="!props.template?.isPrivate"
                            size="medium"
                            type="outline"
                            :style="{
                                'margin-bottom': '12px'
                            }"
                            @click.stop="handleViewDetail"
                        >
                            <template #icon>
                                <pt-icon
                                    icon="pt-icon-view"
                                    :style="{
                                        width: '20px',
                                        height: '20px'
                                    }"
                                ></pt-icon>
                            </template>
                            {{ $t('experience.onboarding.detail') }}
                        </pt-button>
                        <pt-button size="medium" @click.stop="handleCreate">
                            <template #icon>
                                <pt-icon
                                    icon="pt-icon-plus"
                                    :style="{
                                        width: '20px',
                                        height: '20px'
                                    }"
                                ></pt-icon>
                            </template>
                            {{ $t('experience.common.create') }}
                        </pt-button>
                    </template>
                    <!-- 私有模板的管理图标 -->
                    <div @click.stop v-if="props.template?.isPrivate">
                        <pt-dropdown
                            @command="handleCommand"
                            trigger="click"
                            v-if="!isEmpty"
                            :append-to-body="false"
                            :class="$style.more"
                        >
                            <a class="toolbarItem" slot="reference">
                                <svg :class="$style.toolbarIcon" aria-hidden="true">
                                    <use xlink:href="#editor-more"></use>
                                </svg>
                            </a>
                            <template #dropdown>
                                <pt-dropdown-menu>
                                    <pt-dropdown-item
                                        v-for="item in operateList"
                                        :key="item.command"
                                        :command="item.command"
                                    >
                                        {{ $t(item.name) }}
                                    </pt-dropdown-item>
                                </pt-dropdown-menu>
                            </template>
                        </pt-dropdown>
                    </div>
                </div>
            </div>
            <div :class="$style.details">
                <h3 :class="$style.title" :title="props.template?.i18nName">
                    {{ props.template?.i18nName }}
                </h3>
                <!-- <p :class="$style.tags" v-if="!props.template?.isPrivate">
                    <TemplateTag type="Template"></TemplateTag>
                    <template v-for="(item, index) in props.template?.showTags" :key="index">
                        <span :class="$style.category" :title="props.template?.showTags?.join('|')">
                            {{ $t(`experience.onboarding.tags.${item}`) }}
                            <i v-if="index < props.template?.showTags?.length - 1"> | </i>
                        </span>
                    </template>
                </p>
                <p :class="$style.tags" v-else>
                    {{ props.template?.i18nDesc }}
                </p> -->
            </div>
        </template>
        <div v-else :class="$style.blankCard" @click="handleCreate">
            <div :class="$style.iconWrap">
                <pt-icon icon="pt-icon-add1" :class="$style.icon"></pt-icon>
            </div>
            <span :class="$style.text" v-if="props.blankText"> {{ $t(props.blankText) }} </span>
        </div>
    </div>
</template>

<script lang="ts">
import TemplateTag from '@experience/components/template/TemplateTag.vue';
import { debounce } from 'lodash-es';
export default {
    name: 'TemplateCard',
    components: {
        TemplateTag
    }
};
</script>

<script lang="ts" setup>
import { computed, ref, onMounted, onUnmounted, nextTick, watch } from 'vue';
import type { ExperienceTemplateV4 } from '@models/experience/useExperienceTemplatesV4';
import { operateList } from '@experience/static/config/experience.config';
// interface
interface Props {
    src: string;
    template?: ExperienceTemplateV4;
    showLayer?: boolean;
    isEmpty?: boolean;
    blankText?: string;
    isMobile?: boolean;
}
// props
const props = withDefaults(defineProps<Props>(), {
    showLayer: true,
    isEmpty: false,
    isMobile: false
});
// emits
const emit = defineEmits(['view', 'create', 'edit', 'delete']);
// state
const card = ref();
const cardHeight = ref();
// computed
// onMounted
onMounted(() => {
    getCardHeight();
    nextTick(() => {
        window.addEventListener('resize', getCardHeight);
    });
});

onUnmounted(() => {
    window.removeEventListener('resize', getCardHeight);
});

// function
function getCardHeight() {
    cardHeight.value = card.value?.clientWidth
        ? `${(card.value?.clientWidth / 1.36).toFixed(0)}px`
        : '224px';
}

// 私有模板的管理按钮
function handleCommand(command: string) {
    switch (command) {
        case 'Edit':
            handleTemplateEdit();
            break;
        case 'Delete':
            handleDeleteTemplate();
            break;
    }
}
function handleViewDetail() {
    emit('view', props.template);
}
function handleCreate() {
    emit('create', props.template);
}

function handleTemplateEdit() {
    emit('edit', props.template);
}

function handleDeleteTemplate() {
    emit('delete', props.template);
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.template {
    display: flex;
    flex-direction: column;
    .card {
        background-color: $pt-black-30;
        border-radius: 3px;
        padding: 20px;
        height: 224px;
        position: relative;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
        &:hover {
            box-shadow: 0 4px 4px rgba(9, 30, 66, 0.3);
            .buttons {
                display: flex;
            }
        }
        .more {
            position: absolute;
            top: 15px;
            right: 19px;
            cursor: pointer;
            .toolbarIcon {
                width: 20px;
                height: 20px;
                transform: rotate(90deg);
            }
        }
        .buttons {
            display: none;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: linear-gradient(#f4f5f7, rgba(244, 245, 247, 0.9));
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
            :global {
                .pt-button {
                    min-width: 114px;
                }
            }
        }
    }
    .details {
        margin-top: 12px;
        .title {
            font-size: 14px;
            color: $pt-black-600;
            font-weight: 500;
            @include line-clamp(2);
        }
        .tags {
            margin-top: 4px;
            @include line-clamp(2);
            line-height: 20px;
            .category {
                font-size: 12px;
                color: $pt-black-90;
                margin-left: 8px;
            }
        }
    }

    .blankCard {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: $pt-black-30;
        min-height: 300px;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
            box-shadow: 0 4px 4px rgba(9, 30, 66, 0.3);
        }
        .iconWrap {
            border: 1px solid $pt-black-60;
            border-radius: 50%;
            padding: 7px;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon {
                width: 32px;
                height: 32px;
                fill: $pt-black-60;
            }
        }

        .text {
            font-size: 14px;
            color: $pt-black-90;
            margin-top: 8px;
        }
    }
}
</style>
